import { List } from 'immutable';
import get from 'lodash/get';
import { camelizeKeys } from 'humps';
import pluralize from 'pluralize';

import { USER__LOG_OFF } from '../constants';
import { API_CLIENT__ERROR } from '../api-client/constants.api-client';
import { ERRORS__PUSH, ERRORS__POP, ERRORS__REMOVE } from './constants.errors';
import {
  BACKGROUND_JOBS__VALID_STATES,
  BACKGROUND_JOBS__INVALID_STATES,
  BACKGROUND_JOBS__GET,
} from '../background-jobs/constants.background-jobs';
import { REWARD_CODES__POST } from '../reward-codes/constants.reward-codes';

const defaultState = new List();

const pushError = (state, error) => state.push(error);

function handleAxiosError(state, { error: axiosError, originalType }) {
  const data = get(axiosError, 'response.data', {});
  const { errors, status = 500 } = data;
  if (Array.isArray(errors)) {
    const nextErrors = errors.map((currentError) => ({
      ...currentError,
      status,
      axiosError,
      originalType,
    }));
    return state.concat(nextErrors);
  }
  if (data.message) {
    const { image, message } = data;
    return pushError(state, { message, image, axiosError, status, originalType });
  }
  const { name, message } = axiosError.isAxiosError ? axiosError.toJSON() : axiosError;
  return pushError(state, { axiosError, name, message, status, originalType });
}

function handleBackgroundJob(state, { data }) {
  const job = camelizeKeys(data[0]);
  if (!job || BACKGROUND_JOBS__VALID_STATES.includes(job.state)) return state;
  const { errorMessages } = get(job, 'statusInfos', {});
  const message =
    errorMessages && BACKGROUND_JOBS__INVALID_STATES.includes(job.state)
      ? errorMessages.join('\n')
      : `Unknown background job status ${job.state}`;
  const name = job.stateMessage || 'Background Job Error';
  return pushError(state, { message, name, status: 400 });
}

function handleRewardCodesUpload(
  state,
  { number_of_error_uploads: numberOfErrors, number_of_valid_uploads: numberOfUploads },
) {
  if (numberOfErrors === 0) return state;
  const error = new Error(
    `We have accepted ${pluralize('code', numberOfUploads, true)} and rejected ${pluralize(
      'code',
      numberOfErrors,
      true,
    )} because they were duplicating existing ones or had the wrong currency.`,
  );
  return pushError(state, error);
}

export default function (state = defaultState, action) {
  const { apiClientType } = action;
  if (apiClientType === API_CLIENT__ERROR) return handleAxiosError(state, action);
  switch (action.type) {
    case BACKGROUND_JOBS__GET:
      return handleBackgroundJob(state, action);
    case ERRORS__POP:
      return state.pop();
    case ERRORS__REMOVE: {
      const index = state.lastIndexOf(action.payload);
      return index === -1 ? state : state.delete(index);
    }
    case ERRORS__PUSH:
      return pushError(state, action.payload);
    case REWARD_CODES__POST:
      return handleRewardCodesUpload(state, action.data);
    case USER__LOG_OFF:
      return defaultState;
    default:
      return state;
  }
}
